module.exports = __webpack_public_path__ + "static/Wynajem-Ksero-Bizhubc558-fd07862e0f53f1a368eb1e83db4e4324.png";